import React from 'react';

function InstagramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7 0C5.098 0 4.86.009 4.114.042 3.37.077 2.861.194 2.415.368c-.46.178-.851.418-1.24.807-.39.389-.63.78-.808 1.24-.173.446-.29.954-.325 1.7C.007 4.86 0 5.097 0 7c0 1.902.009 2.14.042 2.886.035.745.152 1.253.326 1.699.178.46.418.851.807 1.24.389.389.78.63 1.24.808.447.172.954.29 1.7.325.746.035.983.042 2.885.042 1.902 0 2.14-.009 2.886-.042.745-.035 1.253-.153 1.699-.325a3.44 3.44 0 001.24-.808c.389-.389.63-.779.808-1.24.172-.446.29-.954.325-1.7C13.993 9.14 14 8.903 14 7c0-1.902-.009-2.14-.042-2.886-.035-.745-.153-1.253-.325-1.699a3.436 3.436 0 00-.808-1.24c-.389-.39-.779-.63-1.24-.808-.446-.173-.954-.29-1.7-.325C9.14.007 8.903 0 7 0zm0 1.26c1.868 0 2.091.01 2.83.041.682.032 1.052.146 1.298.243.328.126.56.278.806.522.245.245.397.478.523.806.096.246.21.616.241 1.299.033.738.04.96.04 2.829 0 1.869-.008 2.091-.042 2.83-.036.682-.15 1.052-.246 1.298-.13.328-.28.56-.524.806-.245.245-.481.397-.805.523-.245.096-.622.21-1.304.241-.743.033-.962.04-2.835.04s-2.091-.008-2.834-.042c-.683-.036-1.06-.15-1.304-.246-.332-.13-.56-.28-.805-.524a2.126 2.126 0 01-.525-.805c-.096-.245-.21-.622-.245-1.304l-.001-.04c-.025-.704-.034-.956-.034-2.786 0-1.828.009-2.082.034-2.793l.001-.042c.036-.683.15-1.058.245-1.303.123-.333.28-.56.525-.806a2.07 2.07 0 01.805-.524c.245-.097.613-.21 1.295-.245l.034-.002c.717-.025.957-.034 2.8-.034L7 1.26zM3.405 7a3.594 3.594 0 117.189 0 3.594 3.594 0 01-7.188 0zM7 9.333a2.333 2.333 0 11-.001-4.665A2.333 2.333 0 017 9.333zm3.737-5.23a.84.84 0 10-.001-1.68.84.84 0 000 1.68z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default InstagramIcon;
